var $291f0c3af3715ceb$exports = {};
$291f0c3af3715ceb$exports = {
    "alert": `\u{ACBD}\u{ACE0}`,
    "dismiss": `\u{BB34}\u{C2DC}`
};


export {$291f0c3af3715ceb$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
